function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useState } from 'react';
import AnchorButton from '../../Buttons/AnchorButton/AnchorButton';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import I18n from '../../I18n/I18n/I18n';
import ThemeContext from '../../ThemeContext';
import en from './locales/FilterSelectTypeahead.en.json';
import { SelectTypeahead } from '../SelectTypeahead/SelectTypeahead';
import compose from '../../utils/compose';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import { default as withInputContainer } from '../withInputContainer/withInputContainer';
import { injectIntl } from 'react-intl';
import { withAdditionalIntl } from '../../I18n/AdditionalIntl/AdditionalIntl';
var messages = normalizeLocaleData(en, '@dm/components.filter-select-typeahead');
function toLowerCaseString(value) {
  return typeof value === 'string' ? value.toLowerCase().trim() : '';
}
function FilterSelectTypeahead(props) {
  var maxOptions = props.maxOptions,
    options = props.options,
    value = props.value,
    intl = props.intl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayAll = _useState2[0],
    setDisplayAll = _useState2[1];
  var _useState3 = useState(options || []),
    _useState4 = _slicedToArray(_useState3, 2),
    filtered = _useState4[0],
    setFiltered = _useState4[1];
  var displaySome = filtered.length <= maxOptions;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    canClear = _useState6[0],
    setCanClear = _useState6[1];
  var handleInputChange = useCallback(function (value, action) {
    if (action && action.action === 'menu-close') {
      setDisplayAll(false);
    }
    if (!displayAll) {
      var find = toLowerCaseString(value);
      setFiltered(find.length > 0 ? options.filter(function (option) {
        return toLowerCaseString(option.label).indexOf(find) >= 0;
      }) : options);
    }
  }, [displayAll, setDisplayAll, setFiltered, options]);
  var handleLoadAll = useCallback(function () {
    return setDisplayAll(true);
  }, [setDisplayAll]);
  var displayOptions = useMemo(function () {
    if (displayAll) {
      return options;
    }
    if (displaySome) {
      return filtered;
    }
    if (value) {
      return options.filter(function (option) {
        return option.value === value;
      });
    }
    return [];
  }, [value, displayAll, displaySome, options, filtered]);
  var screenReaderStatus = useMemo(function () {
    if (!displayAll || !displaySome) {
      return function () {
        return intl.formatMessage({
          id: '@dm/components.filter-select-typeahead.filtered'
        }, {
          filtered: filtered.length,
          total: options.length
        });
      };
    }
  }, [intl, displayAll, displaySome, options, filtered]);
  var onKeyDown = useCallback(function (e) {
    setCanClear(false);
    if (displaySome || displayAll) {
      return;
    }
    // Up | Down
    if (e.which === 38 || e.which === 40) {
      handleLoadAll();
    }
    if (e.which === 13) {
      setCanClear(false);
    }
  }, [displaySome, displayAll, handleLoadAll]);
  var handleMenuClose = function handleMenuClose(e) {
    return setCanClear(true);
  };
  var handleMenuOpen = function handleMenuOpen(e) {
    return setCanClear(false);
  };
  var handleOnChange = function handleOnChange(e) {
    props.onChange(e);
    setCanClear(true);
  };
  var loadingMessage = useCallback(function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(I18n, {
      i18n: {
        id: '@dm/components.filter-select-typeahead.filtered',
        values: {
          filtered: filtered.length,
          total: options.length
        }
      }
    }), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
      value: "ripple"
    }, ' ', /*#__PURE__*/React.createElement(AnchorButton, {
      onClick: handleLoadAll
    }, /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: "@dm/components.filter-select-typeahead.show-all"
    }))));
  }, [handleLoadAll, filtered, options]);
  return /*#__PURE__*/React.createElement(SelectTypeahead, Object.assign({
    isLoading: !displayAll && filtered.length > maxOptions && !canClear,
    loadingMessage: loadingMessage
  }, props, {
    screenReaderStatus: screenReaderStatus,
    onInputChange: handleInputChange,
    onKeyDown: onKeyDown,
    options: displayOptions,
    allowCreateWhileLoading: true,
    onMenuClose: handleMenuClose,
    onMenuOpen: handleMenuOpen,
    onChange: handleOnChange
  }));
}
function Wrapper(props) {
  var options = props.options,
    _props$maxOptions = props.maxOptions,
    maxOptions = _props$maxOptions === void 0 ? 100 : _props$maxOptions;
  var Component = options.length > maxOptions ? FilterSelectTypeahead : SelectTypeahead;
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    maxOptions: maxOptions
  }, props));
}
export default compose(withAdditionalIntl(messages), injectIntl, withInputContainer({
  type: 'typeahead'
}))(Wrapper);